import { Document } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useId } from 'react';

import { ContentfulRichText as ContentfulRichTextContent } from '@silvertours/common-landingpages-view';

import { createOptions, createOptionsWithExtraction } from './options';
import {
  ContentColumn,
  ContentfulRichTextWrapper,
  GridWrapper,
  SnippetsColumn,
} from './ContentfulRichText.styles';

import { HasTextStyleRules } from '../rules';
import { AdditionalInfo } from '../../AdditionalInfo';

type ContentfulRichTextRules = HasTextStyleRules;

type ContentfulRichTextProps = {
  content: ContentfulRichTextContent;
  rules?: ContentfulRichTextRules;
  enableSnippetExtraction?: boolean;
};

export const ContentfulRichText = ({
  content,
  rules,
  enableSnippetExtraction = true,
}: ContentfulRichTextProps) => {
  const document = content.text as unknown as Document;
  const id = useId();
  const { options, extractedSnippetsData } = enableSnippetExtraction
    ? createOptionsWithExtraction()
    : { options: createOptions(), extractedSnippetsData: [] };
  const renderedContent = documentToReactComponents(document, options);

  const hasSnippets =
    enableSnippetExtraction && extractedSnippetsData.length > 0;

  return (
    <ContentfulRichTextWrapper textStyle={rules?.textStyle}>
      {enableSnippetExtraction ? (
        <GridWrapper>
          <ContentColumn>{renderedContent}</ContentColumn>
          {hasSnippets && (
            <SnippetsColumn>
              {extractedSnippetsData.map(snippetData => (
                <AdditionalInfo key={`${id}-${snippetData.id}`}>
                  {snippetData.content}
                </AdditionalInfo>
              ))}
            </SnippetsColumn>
          )}
        </GridWrapper>
      ) : (
        renderedContent
      )}
    </ContentfulRichTextWrapper>
  );
};
